<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      line-form
      show-save-button
      unit="出入库类别"
      edit-title
      id-key="WarehouseId"
      :data="data"
      form-label-width="120px"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @opened="onOpened"
      @closed="onClosed"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="出入库类别编码" prop="ClassNo">
          <span v-if="Mode == 0" class="detail-span">{{ data.ClassNo }}</span>
          <el-input
            v-else
            v-model="data.ClassNo"
            placeholder="请输入出入库类别编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="出入库类别名称" prop="ClassName">
          <el-input
            v-model="data.ClassName"
            placeholder="请输入出入库类别名称"
          />
        </el-form-item>
        <el-form-item label="上级类别" prop="Pid">
          <el-select v-model="data.Pid">
            <el-option
              v-for="i in PList"
              :key="i.ClassId"
              :value="i.ClassId"
              :label="i.ClassName"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="序号">
          <el-input
            type="number"
            v-model.number="data.Sn"
            style="width: 100px"
          ></el-input>
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import typeSelect from "./type/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect,
  },
  data() {
    return {
      data: {
        ClassId: 0,
        ClassNo: "",
        ClassName: "",
        Pid: null,
        ClassType: 16,
        Sn: null,
      },
      Mode: 1,
      code_api: require("@/api/sy/serialCode").default,
      api: require("@/api/ba/class").default,
      rules: {
        ClassNo: [{ required: true, message: "出入库类别编码不能为空" }],
        ClassName: [{ required: true, message: "出入库类别名称不能为空" }],
        Pid: [{ required: true, message: "请选择上级类别" }],
      },
      PList: [],
    };
  },
  computed: {},
  methods: {
    serialCode() {
      this.code_api.previewNo("出入库类别").then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.ClassNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取出入库类别编号失败");
        }
      });
    },
    onOpened() {
      this.api.list({ ClassType: 16 }).then((res) => {
        this.PList = res.Data.filter((i) => i.Pid === 0);
      });
    },
    onCreateOpened(data) {
      this.serialCode();
      this.api.getMaxSn( 16 ,this.data.Pid).then((res) => {
        this.data.Sn = res;
      });
    },
    onEditOpened(data) {},
    onClosed() {
      // $refs.typeSelect.clear()
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>
